import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';
import type React from 'react';
import { SURFACE_CONTAINER_LOW } from 'styles/tokens';

interface CenteredContainerProps
  extends Omit<BoxProps, 'display' | 'flexDirection' | 'justifyContent' | 'alignItems' | 'height'> {
  children: React.ReactNode;
  p?: number;
  bgcolor?: string;
}

/**
 * A centered full-screen container component used for loading states, error messages,
 * and other centered content that needs to take up the full viewport height.
 */
const CenteredContainer = ({ children, p = 3, bgcolor = SURFACE_CONTAINER_LOW, ...rest }: CenteredContainerProps) => (
  <Box
    {...rest}
    sx={[
      {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        bgcolor,
        p,
      },
      ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
    ]}
  >
    {children}
  </Box>
);

export default CenteredContainer;
